import { DomainSerializer } from "src/app/global/serializables/domain.serializer";
import { Parcela } from "../domain/parcela.model";

export class ParcelaSerializer extends DomainSerializer<Parcela> {}